module.exports = __webpack_public_path__ + "img/collection3.d5f84f0a.png";